import React from 'react';

import { AutoComplete, message } from 'antd';

import sessionManager, { eVariableType } from '../SessionManager';
import api from '../api';
import stringres from '../translations/stringres';

interface CmbClientiProps {
    onselected: (p: any) => void;
    ragioneSociale: string;
    value: any;
}

type CmbClientiModel = {
    codCliente: string;
    ragioneSociale: string;
};

export default function CmbClienti(props: CmbClientiProps) {
    const [suggestions, setSuggestions] = React.useState<CmbClientiModel[]>([]);

    async function handleSearch(value) {
        try {
            if (value != null && value.length > 2) {
                const result = await api.get(
                    'CRM/Clienti?indice=0&numeroRecord=10&idSocieta=' +
                        sessionManager.get(eVariableType.IDSocieta) +
                        '&ragioneSociale=' +
                        value
                );

                if (result != null && result.data != null) {
                    setSuggestions(result.data);
                }
            }
        } catch (error) {
            message.error(error.message.response.data.message);
        }
    }

    async function OnSelect(item, opt) {
        const rx = suggestions.filter((x) => x.codCliente === opt.key);
        if (rx != null) props.onselected(rx[0]);
    }

    return (
        <AutoComplete
            onSearch={handleSearch}
            options={suggestions.map((customer) => ({
                value: customer.ragioneSociale,
                label: customer.ragioneSociale,
                key: customer.codCliente,
            }))}
            onSelect={OnSelect}
            value={props.ragioneSociale}
            allowClear={true}
            placeholder={stringres.t('campodiricercaclienti').toString()}
        ></AutoComplete>
    );
}
